export default __webpack_public_path__ + "static/media/Empty.31d6c47f.svg";